export default __webpack_public_path__ + "images/wall_pvc_white_14d5d89b69a75eef5003726ba3134ebf.png";